import { render, staticRenderFns } from "./queryPuArrearsReportList.vue?vue&type=template&id=1b7f6f10"
import script from "./queryPuArrearsReportList.vue?vue&type=script&lang=js"
export * from "./queryPuArrearsReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports